import { TEXTS } from '@/views/PesosCocidos/cookedWeightsConstants'
import { formatWeight } from '@/views/PesosCocidos/weightDisplay'
import { formatKilograms } from '@/utils/kilosFormat'

function roundsToZeroKilograms (grams) {
  return Number(formatKilograms(Number(grams))) === 0
}

function formatIngredientWeight (grams) {
  return roundsToZeroKilograms(grams) ? TEXTS.LESS_THAN_ONE_GRAM : formatWeight(grams)
}

export function buildIngredientRows (ingredients) {
  return ingredients.map((ingredient) => ({
    key: ingredient.ingredient_id,
    label: ingredient.ingredient_name,
    value: formatIngredientWeight(ingredient.day_grams)
  }))
}
